import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { RelationshipActions } from '../../../actions/relationship';
import { validateAndDispatch } from '../../../helpers/form';
import DeleteConfirmationModal from './DeleteConfirmationModal';

export default class RelItem extends Component {
  static propTypes = {
    activeElementId: PropTypes.string.isRequired,
    predecessor: PropTypes.instanceOf(Map).isRequired,
    inlineTypeOptions: PropTypes.object,
    currentProjectId: PropTypes.string,
    dispatch: PropTypes.func,
    existingPredecessors: PropTypes.array,
    relationshipDirection: PropTypes.string,
    relationshipType: PropTypes.string,
  };

  constructor() {
    super();

    this.state = {
      showDeleteConfirmationModal: false,
    };

    this.handleDeleteRel = this.handleDeleteRel.bind(this);
  }

  getActualRelPropSize = () => {
    const { predecessor } = this.props;
    const filtered = predecessor.get('relProps').filter((v, k) => {
      console.log('v', v, typeof v, k);
      if (Map.isMap(v) === false) return false;
      const isTorn = v.get('hidden', null);
      return k === 'Assumption' && isTorn === true;
    });
    return filtered.size;
  };

  handleDeleteRel = async () => {
    const {
      dispatch,
      activeElementId,
      predecessor,
      relationshipType,
      currentProjectId,
      existingPredecessors,
      relationshipDirection,
    } = this.props;

    const otherElementIds = existingPredecessors.filter(
      item => item !== predecessor.get('id'),
    );
    const action = RelationshipActions.patchRelationships(
      {
        relationshipDirection,
        relationshipType,
        elementId: activeElementId,
        otherElementIds,
        strength: 1,
      },
      currentProjectId,
    );

    await validateAndDispatch(dispatch, action, {}, {}).then(() => {});
  };

  toggleModal = () => {
    this.setState({
      showDeleteConfirmationModal: !this.state.showDeleteConfirmationModal,
    });
  };

  render() {
    const { predecessor } = this.props;
    const propSize = this.getActualRelPropSize();
    const propWord = propSize === 1 ? 'property' : 'properties';

    const relPropWarning =
      propSize > 0 ? (
        <div style={{ flex: '0 1 100%' }}>
          <i
            className="fa fa-info-circle text-info"
            style={{ marginRight: 5, verticalAlign: 'middle' }}
          />
          <em style={{ fontFamily: 'Arial', fontSize: 12 }}>
            This relationship has {propSize} {propWord}.
          </em>
        </div>
      ) : null;

    const deleteRel = propSize === 0 ? this.handleDeleteRel : this.toggleModal;

    return (
      <li
        className="list-group-item"
        style={{
          padding: '.25rem .75rem',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          alignItems: 'flex-start',
        }}
      >
        <div style={{ fontSize: 13, flex: '1 0 50%', lineHeight: '26px' }}>
          {predecessor.get('name')}
        </div>
        <div style={{ flex: '0 0 15px', justifyContent: 'center' }}>
          <button
            className="action-btn btn btn-danger btn-xs"
            style={{}}
            onClick={deleteRel}
          >
            <i className="fa fa-times" />
            {this.state.showDeleteConfirmationModal &&
              predecessor.get('relProps').size > 0 && (
                <DeleteConfirmationModal
                  showModal={this.state.showDeleteConfirmationModal}
                  handleCloseModal={this.toggleModal}
                  deleteRelationship={this.handleDeleteRel}
                  contentLabel="Warning - You are about to delete this relationship"
                  relProps={predecessor.get('relProps')}
                />
              )}
          </button>
        </div>

        {relPropWarning}
      </li>
    );
  }
}
// const RelItem = (props) => <li key={props.key}>{props.name}</li>;
// RelItem.propTypes = {
//   key: PropTypes.number.isRequired,
//   name: PropTypes.string.isRequired,
// };



// WEBPACK FOOTER //
// ./src/components/modals/AssignPredecessorModal/RelItem.js